const Loading = () => {
	return (
		<div><span className="timer-loader"></span></div>
	)
}

export default Loading